import React from 'react';
import _ from 'lodash';
import fetchJsonp from 'fetch-jsonp';
import loadScript from 'load-script';
import rawMarkup from '../util/rawMarkup';

const TWITTER_JS_PATH = '//platform.twitter.com/widgets.js';
const TWITTER_API_PATH = 'https://api.twitter.com/1/statuses/oembed.json';
const TWEET_MAXWIDTH = 420;

export default class TweetRenderer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { html: null };
  }

  componentDidMount() {
    this.updateTweet(this.props.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.updateTweet(nextProps.id);
    }
  }

  componentDidUpdate() {
    // TODO: It seems as if twttr is defined before twttr.widgets
    // Investigate if running loadScript multiple times can cause issues
    if (this.state.html) {
      if (_.get(window, 'twttr.widgets')) {
        window.twttr.widgets.load(this.refs.container);
      } else {
        loadScript(TWITTER_JS_PATH);
      }
    }
  }

  updateTweet(id) {
    fetchJsonp(`${TWITTER_API_PATH}?omit_script=true&maxwidth=${TWEET_MAXWIDTH}&id=${id}`)
      .then((response) => response.json())
      .then((result) => this.setState({ html: result.html }));
  }

  render() {
    return this.state.html &&
      <div className="tweet-container" ref="container" style={{ maxWidth: TWEET_MAXWIDTH, margin: '0 auto' }} dangerouslySetInnerHTML={rawMarkup(this.state.html)} />;
  }
}

TweetRenderer.propTypes = {
  id: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/component/TweetRenderer.jsx